var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 1.1v3.5h-2.1c-.8 0-1.3.2-1.5.5-.3.3-.4.8-.4 1.4V9h3.9l-.5 4h-3.4v10H9.6V13H6.3V9h3.4V6.1c0-1.6.5-2.9 1.4-3.8.8-.9 2.1-1.3 3.6-1.3 1.3 0 2.3 0 3 .1z"
  })));
};
export { SvgFacebook as ReactComponent };